import {Card, Table} from 'antd';
import {ColumnProps} from 'antd/lib/table';
import {TableCard} from 'components/TableCard';
import {formatAmount, formatDate} from 'lib/formaters';
import React, {useState} from 'react';
import styled from 'styled-components';
import {SectionProps} from '../utils/types';
import {AffiliateInvoice, Currencies, useAffiliateInvoicesQuery} from 'api/generated';
import {AffiliateInvoiceStatusTag} from 'components/AffiliateInvoiceStatusTag';
import moment from 'moment';
import {DownloadAffiliateInvoice} from './DownloadAffiliateInvoice';
const Amount = styled.span`
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
`;

export const AffiliateInvoiceHistory: React.FC<SectionProps> = ({
  affiliate,
  payoutMethod,
  cardProps
}) => {
  const [from, setFrom] = useState(0);
  const [size, setSize] = useState(10);

  const {data, loading, previousData} = useAffiliateInvoicesQuery({
    variables: {
      taxId: payoutMethod?.details?.nif || ''
    },
    skip: !payoutMethod?.details?.nif
  });

  const payload = data ?? previousData;
  const invoices = payload?.affiliateInvoices.items || [];
  const total = payload?.affiliateInvoices.total || 0;
  if (!invoices || !affiliate) return <Card {...cardProps} title="Invoices" />;

  const columns: Array<ColumnProps<AffiliateInvoice>> = [
    {
      title: 'Amount',
      dataIndex: 'amount',
      className: 'minimized-cell',
      align: 'right',
      render(amount: number) {
        return <Amount>{formatAmount(amount, Currencies.EUR, 2)}</Amount>;
      }
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render(_, invoice) {
        return <AffiliateInvoiceStatusTag invoice={invoice} />;
      }
    },
    {
      title: 'Number',
      dataIndex: 'number',
      render(number: string) {
        return number || 'N/A';
      }
    },
    {
      title: 'Issued on',
      dataIndex: 'issuedAt',
      render: (issuedAt) => formatDate(issuedAt, 'YYYY-MM-DD')
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      align: 'right',
      className: 'minimized-cell',
      render: (_, invoice) => (
        <DownloadAffiliateInvoice
          invoiceNumber={invoice.number || ''}
          affiliateId={affiliate.id}
          year={moment(invoice.issuedAt, 'YYYY-MM-DD').format('YYYY')}
        />
      )
    }
  ];

  return (
    <>
      <TableCard {...cardProps} title="Payouts history">
        <Table
          rowKey="id"
          scroll={{x: true}}
          dataSource={invoices}
          columns={columns}
          loading={loading}
          pagination={{
            pageSize: size,
            current: from / size + 1,
            total: total,
            showSizeChanger: true,
            onChange: (page, size = 0) => setFrom((page - 1) * size),
            onShowSizeChange: (page, size) => setSize(size)
          }}
        />
      </TableCard>
    </>
  );
};
